import type { FC } from 'react';

import { LocalizedAmount } from '@shared/core-ui-amount';

import { HighlightCard } from '../components/HighlightCard';

type HighlightCardProps = Omit<Parameters<typeof HighlightCard>[0], 'value'>;

type Props = HighlightCardProps & {
    percentage: number;
};

export const PercentageHighlight: FC<Props> = ({
    icon,
    label,
    percentage,
    'data-cy': dataCy,
    valuePostfix,
    illustration,
}) => (
    <HighlightCard
        data-cy={dataCy}
        icon={icon}
        label={label}
        illustration={illustration}
        value={
            <LocalizedAmount
                data-cy={`${dataCy}-highlight-percentage`}
                amount={{ value: percentage, precision: 0, currency: '%' }}
                showCurrency
            />
        }
        valuePostfix={valuePostfix}
    />
);
